import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
export var useCurrentSlide = function useCurrentSlide(initialSlide) {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentSlide = _useState2[0],
      setCurrentSlide = _useState2[1];

  useEffect(function () {
    if (initialSlide && initialSlide > 0) setCurrentSlide(initialSlide);
  }, [initialSlide]);
  return [currentSlide, setCurrentSlide];
};